export const socialNotifications = {
  socialNotifTitle: "Activity",
  socialNotifMarkAll: "Mark all as read",
  socialNotifEmpty: "No activity yet",
  socialNotifEmptyDesc: "When there's new activity, you'll see it here",
  socialNotifJustNow: "Just now",
  socialNotifMinAgo: "{{count}}m ago",
  socialNotifHrsAgo: "{{count}}h ago",
  socialNotifDaysAgo: "{{count}}d ago",
  socialNotifWeeksAgo: "{{count}}w ago",
  socialNotifFollowers: "Followers",
  socialNotifPrizes: "Prizes",
  socialNotifNewGames: "New Games",
  socialNotifPromos: "Promos",
  socialNotifTournaments: "Tournaments",
  socialNotifComments: "Comments",
};
